import { useEffect, useState } from "react";
import { EnquiriesPanel } from "@/components/EnquiryThread";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, Lock, ShoppingBag } from "lucide-react";
import { api } from "@/lib/api";

/** Seller dashboard: shows whether Buy now is live on their listings, the two steps to unlock it, and incoming enquiries. */
export function SellingUnlockCard() {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/billing/status").then(({ data }) => setS(data)).catch(() => {});
  }, []);

  if (!s || s.role === "admin") return null;
  const steps = [
    { done: s.is_active, label: `Activate your seller plan ($${Math.round(s.monthly_fee_usd)}/mo or $${Math.round(s.annual_fee_usd)}/yr)`, href: "/billing", cta: "Subscribe" },
    { done: s.kyc_status === "verified", label: s.kyc_status === "pending" ? "ID uploaded — awaiting review" : "Upload your ID for verification", href: "/payouts", cta: s.kyc_status === "pending" ? "View" : "Verify" },
  ];

  return (
    <div data-testid="selling-unlock-card" className={`mt-6 rounded-xl border p-5 ${s.can_sell ? "border-[#34C759]/40 bg-[#34C759]/[0.05]" : "border-[#FF9F0A]/40 bg-[#FF9F0A]/[0.05]"}`}>
      <div className="flex flex-col md:flex-row md:items-start gap-5">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            {s.can_sell ? <ShoppingBag className="h-4 w-4 text-[#34C759]" /> : <Lock className="h-4 w-4 text-[#FF9F0A]" />}
            <div className="font-bold text-white" data-testid="selling-status">
              {s.can_sell ? "Buy now is live on your listings" : "Your listings are in showcase mode"}
            </div>
          </div>
          <p className="text-sm text-neutral-400 mt-1">
            {s.can_sell
              ? "Buyers can pay you directly. Keep your payout channel connected so every sale settles to you."
              : `Your first ${s.starter_free_listings} products are shown free in the feed and on your Stage with “Message / enquire”. Complete both steps and the Buy button switches on.`}
          </p>
          {!s.can_sell && (
            <ul className="mt-3 space-y-2">
              {steps.map((st, i) => (
                <li key={i} className="flex items-center justify-between gap-3 text-sm" data-testid={`selling-step-${i}`}>
                  <span className="flex items-center gap-2">
                    {st.done ? <CheckCircle2 className="h-4 w-4 text-[#34C759]" /> : <Circle className="h-4 w-4 text-neutral-600" />}
                    <span className={st.done ? "text-neutral-500 line-through" : "text-neutral-200"}>{st.label}</span>
                  </span>
                  {!st.done && <Link to={st.href} className="text-xs font-bold text-[#FF9F0A] hover:underline" data-testid={`selling-step-${i}-cta`}>{st.cta} →</Link>}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="md:w-96 rounded-lg border border-white/10 bg-black/30 p-3" data-testid="enquiries-list">
          <EnquiriesPanel side="seller" compact />
        </div>
      </div>
    </div>
  );
}
